// Central configuration loader
import devConfig from '../../app.config.json';
import prodConfig from '../../app.config.prod.json';

export interface AppConfig {
  readonly OAUTH_URL: string;
  readonly CLIENT_ID: string;
  readonly API_URL: string;
  readonly EXPORT_TYPE: string;
  readonly SCOPE: string;
  readonly STORYBOOK_BASE_URL: string;
}

// Determine which config to use based on build configuration
export const BUILD_CONFIG = process.env.REACT_APP_BUILD_CONFIG || 'NONPROD';
const isProd = BUILD_CONFIG === 'PROD';

// Load the appropriate config based on build configuration
// This selection happens once at build time
const config: AppConfig = isProd ? prodConfig : devConfig;

// Basic validation - ensure config was loaded
if (!config) {
  throw new Error(`Failed to load configuration file: ${isProd ? 'app.config.prod.json' : 'app.config.json'}`);
}

export default Object.freeze(config);
